import { createSlice } from "@reduxjs/toolkit";
import fetchPendingVotesAsync from "../actions/votingFormAction";

const initialState = {
  pendingVotes: [],
  loading: false,
  error: null,
};

export const votingFormSlice = createSlice({
  name: "votingForm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingVotesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingVotesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingVotes = action.payload;
      })
      .addCase(fetchPendingVotesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const votingFormReducer = votingFormSlice.reducer;
export default votingFormReducer;
